import React, { Component } from 'react'
import actions from "../../search/index/actions/root_action"
import { connect } from "react-redux"
import { withNamespaces } from "react-i18next"
import { compose } from "redux"
import '../../i18n'
import Modal from '../../common/components/modal_dialog/modal_wrapper_component'
import ListingFinder from "./listing_finder"
import ListingRelax from "./listing_relax"
import ListingPopular from "./listing_popular"
import PropertyListings from "./property_listings"
import './main_container.scss'

const relaxedQuery = {
  adults: 2,
  room_types: 'entire_home',
  price_min: 5000
}

const housesQuery = {
  adults: 2,
  property_types: 'house'
}

const apartmentsQuery = {
  adults: 2,
  property_types: 'apartment'
}

const pickupSize = 8

export class Main extends Component {
  render() {
    const { t } = this.props
    return (
      <React.Fragment>
        <div styleName="wrapper">
          <ListingFinder />
          <div styleName="contents-wrapper">
            <ListingRelax link={routeUrlHelper.countrySearchPath('vn', relaxedQuery)}>
              <PropertyListings query={this.searchQuery(relaxedQuery)} namespace="relaxed" disableMoreLink={true} />
            </ListingRelax>

            <ListingPopular />

            <PropertyListings heading={t('vietnam:vietnam.villa')} query={this.searchQuery(housesQuery)} namespace="houses" />

            <PropertyListings heading={t('vietnam:vietnam.apartment')} query={this.searchQuery(apartmentsQuery)} namespace="apartments" />
          </div>
        </div>
        <Modal />
      </React.Fragment>
    )
  }

  searchQuery(query) {
    return {
      country_code: 'vn',
      limit: pickupSize,
      sort: 'random',
      ...query
    }
  }
}

const mapStateToProps = (state) => {
  return {
    login: state.login,
    language: state.language,
    modal: state.modal,
    propertyTypes: state.propertyTypes,
    search: state.search
  }
}

const mapDispatchToProps = (dispatch, state) => {
  return {
    actions: actions(dispatch)
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withNamespaces()
)(Main)
